import {$, w} from './constants';
export function sliderGrab() {
    const sliders = document.querySelectorAll('.slider--grab');

    sliders.forEach(slider => {
        const container = slider.closest('.slider-container');
        if (!container) return;

        const leftArrow = container.querySelector('.slider-arrow--left');
        const rightArrow = container.querySelector('.slider-arrow--right');

        // Función para verificar el desbordamiento y mostrar/ocultar flechas
        const checkScroll = () => {
            if (slider.scrollWidth > slider.clientWidth) {
                container.classList.add('show-arrows');
            } else {
                container.classList.remove('show-arrows');
            }
        };

        checkScroll();
        window.addEventListener('resize', checkScroll);

        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3;
            slider.scrollLeft = scrollLeft - walk;
        });

        //Funcionalidad de las flechas
        const scrollAmount = 200;
        if (leftArrow && rightArrow) {
            leftArrow.addEventListener('click', () => {
                slider.scrollTo({
                    left: slider.scrollLeft - scrollAmount,
                    behavior: 'smooth'
                });
            });

            rightArrow.addEventListener('click', () => {
                slider.scrollTo({
                    left: slider.scrollLeft + scrollAmount,
                    behavior: 'smooth'
                });
            });
        }

        const observer = new MutationObserver(checkScroll);
        observer.observe(slider, { childList: true });
    });
}

export function sameHeightSliders(containerClass) {
    console.log('Buscando sliders con la clase:', containerClass);

    const sliders = $(containerClass);

    sliders.each(function() {
        const slider = $(this);
        const blocks = slider.find('.slider-block');

        let maxHeight = 0;

        // Restablecer altura antes de calcularla
        blocks.find('.data-container').css('height', '');

        // Calcular la altura máxima para este slider
        blocks.each(function() {
            const dataContainerHeight = $(this).find('.data-container').outerHeight();
            maxHeight = Math.max(maxHeight, dataContainerHeight);
        });

        // Aplicar la altura máxima a todos los contenedores de este slider
        blocks.each(function() {
            $(this).find('.data-container').css('height', maxHeight + 'px');
        });
    });
}

export function initializeSidebarSliders( sliderId ){
    $(sliderId).each(function(){
        $(this).slick({
            arrows: true,
            prevArrow: "<div class='arrow-sidebar arrow-sidebar--left'>",
            nextArrow: "<div class='arrow-sidebar arrow-sidebar--right'>",
            infinite: false,
            autoplay: false,
            speed: 250, // Velocidad del fade entre slides (250ms)
            lazyLoad: 'ondemand',
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1
        });
    });
}

export function sliderEvents(containerClass){
    $(containerClass).slick({
        arrows: true,
        prevArrow: "<div class='arrow-event arrow-event--left'>",
        nextArrow: "<div class='arrow-event arrow-event--right'>",
        dots: false,
        infinite: false,
        autoplay: false,
        speed: 800,
        cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
        touchThreshold: 10,
        useTransform: true,
        waitForAnimate: false,
        variableWidth: true,
        adaptiveHeight: false,
        slidesToScroll: 1
    });
    // 👇 Detectar imágenes demasiado horizontales y aplicar clase
    const $slider = $(containerClass);

    $slider.find('.events__forum-slider-block img').each(function () {
        const img = this;

        const applyWideClass = () => {
            const ratio = img.naturalWidth / img.naturalHeight;
            if (ratio > 2) {
                img.classList.add('wide-image');
            }
        };

        if (img.complete) {
            applyWideClass();
        } else {
            img.addEventListener('load', applyWideClass);
        }
    });
}